const blockQuestionPath = () => {
  const answers = [
    {
      question1: false,
      question2: false,
      question3: false,
      answer: 'Adoption<sup>7</sup>',
      link: '/alternative-options/#adoption',
    },
    {
      question1: true,
      question2: false,
      question3: false,
      answer: 'Traditional surrogacy<sup>5,6</sup>',
      link: '/alternative-options/#surrogacy',
    },
    {
      question1: true,
      question2: true,
      question3: false,
      answer: 'Gestational surrogacy<sup>5</sup>',
      link: '/alternative-options/#surrogacy',
    },
    {
      question1: true,
      question2: false,
      question3: true,
      answer: 'Egg donation (prior to ART)<sup>4</sup>',
      link: '/sperm-egg-or-embryo-donation/',
    },
    {
      question1: false,
      question2: false,
      question3: true,
      answer:
        'Sperm + egg donation or embryo donation (prior to ART)<sup>4</sup>',
        link: '/sperm-egg-or-embryo-donation/',
    },
    {
      question1: false,
      question2: true,
      question3: true,
      answer: 'Sperm donation (prior to ART)<sup>4</sup>',
      link: '/sperm-egg-or-embryo-donation/',
    },
    {
      question1: true,
      question2: true,
      question3: true,
      answer:
        'Unassisted/assisted pregnancy<sup>1,2</sup> or assisted reproductive technology (ART)<sup>3</sup>',
      link: '/assisted-reproductive-technology/',
    },
    {
      question1: false,
      question2: true,
      question3: false,
      answer:
        'Gestational surrogacy using donated sperm<sup>5</sup>',
        link: '/alternative-options/#surrogacy',
    },
  ];
  let userAnswer = {
    question1: false,
    question2: false,
    question3: false,
  };
  // reset on page load
  reset();
  $('.option').on('click', function () {
    // get current option check
    const idd = $(this).attr('id');

    // get checkbox value
    const checkbox = $('input[id^=' + idd + ']');
    userAnswer[idd] = checkbox[0].checked;

    if ($('.final-result').hasClass('show')) {
      getResult();
    }
  });

  $('.js-see-result').on('click', function () {
    getResult();
    $('.option').prop('disabled', true);
  });

  $('.js-reset').on('click', function () {
    reset();
  });

  function reset() {
    $('.final-result').removeClass('show');
    $('.see-result').addClass('show');
    $('.option').prop('disabled', false);
    $('.option').prop('checked', false);
    userAnswer = {
      question1: false,
      question2: false,
      question3: false,
    };
  }

  function getResult() {
    // Find the matching answer and link
    const result = getMatchingAnswer(userAnswer, answers);
    if (result) {
      $('.final-result').addClass('show');
      $('.js-answer').html(result.answer);
      $('.js-find-out-more').attr('href', result.link);
      $('.see-result').removeClass('show');
    }
  }

  // Function to find the matching answer based on userAnswer
  function getMatchingAnswer(userAnswer, answers) {
    for (let i = 0; i < answers.length; i++) {
      const answerObj = answers[i];
      let isMatch = true;

      // Check if all question values match
      for (const question in userAnswer) {
        if (userAnswer[question] !== answerObj[question]) {
          isMatch = false;
          break;
        }
      }

      // Return answer and link if all questions match
      if (isMatch) {
        return { answer: answerObj.answer, link: answerObj.link };
      }
    }

    // Return null if no match is found
    return null;
  }
};

export default blockQuestionPath;
